// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const OnboardingPlaybackMoon = (props: SVGProps<SVGSVGElement>) => (
	<svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M3.475 15.323a9.071 9.071 0 0 0 8.348 5.552c4.99 0 9.05-4.042 9.05-9.01a8.97 8.97 0 0 0-5.878-8.431 8.983 8.983 0 0 1 .677 3.413c0 4.98-4.067 9.032-9.067 9.032a8.975 8.975 0 0 1-3.13-.556Zm8.348 6.552c-4.499 0-8.478-3.019-9.677-7.341a.5.5 0 0 1 .713-.577c1.17.611 2.43.922 3.746.922 4.448 0 8.067-3.603 8.067-8.032a8 8 0 0 0-1.062-3.973.5.5 0 0 1 .549-.735c4.542 1.079 7.714 5.078 7.714 9.727 0 5.519-4.508 10.009-10.05 10.009Zm-5.83-15.13c.497.279.888.67 1.166 1.167a2.98 2.98 0 0 1 1.167-1.166A2.98 2.98 0 0 1 7.159 5.58a2.976 2.976 0 0 1-1.166 1.166Zm1.166 3.876a.5.5 0 0 1-.5-.5c0-1.935-.94-2.875-2.877-2.875a.5.5 0 0 1 0-1c1.936 0 2.877-.94 2.877-2.875a.5.5 0 0 1 1 0c0 1.934.941 2.875 2.878 2.875a.5.5 0 0 1 0 1c-1.937 0-2.878.94-2.878 2.875a.5.5 0 0 1-.5.5Z"
			fill="url(#OnboardingPlaybackMoon_tsx__a)"
		/>
		<defs>
			<linearGradient
				id="OnboardingPlaybackMoon_tsx__a"
				x1={2.127}
				y1={2.125}
				x2={21.878}
				y2={21.87}
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#75F0F0" />
				<stop offset={1} stopColor="#7575F0" />
			</linearGradient>
		</defs>
	</svg>
);
export default OnboardingPlaybackMoon;
